/**
 * @module client/index 
 */

/** 
 * 调取客户端方法
 * @fileoverview 调取客户端方法
 * @author Rfan
 */
import { testPlatform } from "@/utils";
/**
 * @typedef {Object} userInfo
 * @property {number} userId - userId
 * @property {string} token token
 * @property {string} nick 姓名
 * @property {string} avatar 头像
 */
/**
 * @description 获取会员信息
 * @function
 * @returns {userInfo} 会员信息
 * @see {@link userInfo}
 */

export function getUserInfo() {
  return window.hsj.getUserInfo();
}

/**
 * @typedef {Object} verInfo
 * @property {number} verCode 版本号
 * @property {string} verName 版本名字
 */
/**
 * 安卓获取软件版本信息
 * @returns {verInfo} 软件版本信息
 */
export function getAppVerInfo() {
  return window.hsj.getVerInfo();
}

/**
 * 客户端主动调取——用户信息回调
 * @param {string} data JSON
 */
export function getUserInfoSuccess(data) {
  console.log('getUserInfoSuccess: ', data);
  const vueNode = app.__vue__;
  vueNode.$children[0].userInfoCb(data)
}

/**
 * 客户端主动调取——软件版本信息回调
 * @param {string} data JSON
 */
export function getAppVerInfoSuccess(data) {
  console.log('getAppVerInfoSuccess: ', data);
  const vueNode = app.__vue__;
  vueNode.$children[0].versionCb(data)
}

/**
 * 联系客服
 */
export function callService() {
  console.log('call service');

  if (testPlatform("ios")) {
    console.log("call service ios ");
    setupWebViewJavascriptBridge(function (bridge) {
      bridge.callHandler("callService", {}, function () { });
    });
  } else {
    console.log("call service android ");
    window.hsj.callService();
  }
}


/*  ------  🍎 ios  ------  */
/**
 * This callback type is called `requestCallback` and is displayed as a global symbol.
 *
 * @callback iosCallback
 * @param {any} func 需要执行的方法
 */

/**
 * 🍎ios客户端方法
 * @param {iosCallback} callback - The callback that handles the response.
 */
export function setupWebViewJavascriptBridge(callback) {
  if (window.WebViewJavascriptBridge) {
    return callback(WebViewJavascriptBridge);
  }
  if (window.WVJBCallbacks) {
    return window.WVJBCallbacks.push(callback);
  }
  window.WVJBCallbacks = [callback];
  var WVJBIframe = document.createElement("iframe");
  WVJBIframe.style.display = "none";
  WVJBIframe.src = "https://__bridge_loaded__";
  document.documentElement.appendChild(WVJBIframe);
  setTimeout(function () {
    document.documentElement.removeChild(WVJBIframe);
  }, 0);
}
